import { compose } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import {
  AvailableFeaturesForm,
  BestDayTime,
  BestDayTimePageForm,
  ConfigurationPageForm,
  MessageFrequencyCapping,
} from '../../../constants';
import { initialize, journeyBuilderFinish, setStep } from '../../../../../Root/actions';
import journeyStatusEnums from '../../../../../Enums/journeyStatus';
import NavigationButtonsComponent from './NavigationButtonsComponent';

const styles = {
  submit: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    padding: '0 64px 32px',
    position: 'auto',
    bottom: 0,
    left: 0,
    width: '100%',
    border: 'none !important',
  },
  rightBtns: {
    marginLeft: '10px !important',
  },
};

export const mapStateToProps = state => {
  const { activities } = state.journeyBuilderConfigurationArea.interaction;
  const { activity } = state.journeyBuilderConfigurationArea;
  const { steps } = state.journeyBuilderConfigurationArea;
  const journeyId = state.journeyBuilderConfigurationArea.interaction.id;
  const journeyVersion = state.journeyBuilderConfigurationArea.interaction.version;
  const journeyStatus = state.journeyBuilderConfigurationArea.interaction.status;
  const status =
    journeyStatus === journeyStatusEnums.DRAFT || journeyStatus === journeyStatusEnums.PAUSED
      ? false
      : true;
  const buId = state.journeyBuilderUIDataArea.userData.value.organization.id;

  let channelCode = null;
  let timePeriod = null;
  let metric = null;
  let bestDayTimeChannel = null;
  let disabled = false;

  const availableFeaturesSelector = formValueSelector(AvailableFeaturesForm);
  const activityType = availableFeaturesSelector(state, 'activityType');
  if (_.includes(activityType, MessageFrequencyCapping)) {
    const configurationPageSelector = formValueSelector(ConfigurationPageForm);
    channelCode = configurationPageSelector(state, 'channel');
    timePeriod = configurationPageSelector(state, 'timePeriod');
    disabled = !channelCode || !timePeriod;
  }
  if (_.includes(activityType, BestDayTime) && disabled === false) {
    const bestDayTimeFeaturesSelector = formValueSelector(BestDayTimePageForm);
    metric = bestDayTimeFeaturesSelector(state, 'metric');
    bestDayTimeChannel = bestDayTimeFeaturesSelector(state, 'bestDayTimeChannel');
    disabled = !metric;
  }

  disabled = status
    ? true
    : !_.isNil(bestDayTimeChannel) && !_.isNil(channelCode) && channelCode !== bestDayTimeChannel
      ? !_.isEmpty(bestDayTimeChannel)
        ? true
        : disabled
      : disabled;

  return {
    steps,
    buId,
    activities,
    activity,
    journeyId,
    journeyVersion,
    channelCode,
    timePeriod,
    activityType,
    metric,
    bestDayTimeChannel,
    disabled,
  };
};

export const mapDispatchToProps = dispatch => {
  const closeActivity = () => {
    dispatch(journeyBuilderFinish());
  };
  return {
    handleSetPage: data => dispatch(setStep(data)),
    closeActivity,
    dispatch,
  };
};

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    buId,
    activities,
    activity,
    journeyId,
    journeyVersion,
    channelCode,
    timePeriod,
    activityType,
    metric,
    bestDayTimeChannel,
  } = stateProps;
  const activityKey = activity.key;
  const successCallback = () => {
    dispatchProps.dispatch(journeyBuilderFinish());
  };

  const handleSubmit = () =>
    dispatchProps.dispatch(
      initialize(
        {
          buId,
          activityKey,
          journeyId,
          journeyVersion,
          channelCode,
          timePeriod,
          activityType,
          activities,
          metric,
          // eslint-disable-next-line object-shorthand, iqvia/ternaries/no-null-ternary
          bestDayTimeChannel: bestDayTimeChannel ? bestDayTimeChannel : null,
        },
        successCallback
      )
    );

  return { ...stateProps, ...ownProps, ...dispatchProps, handleSubmit };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  injectIntl,
  withStyles(styles, { name: 'NavigationButtonsComponent' })
)(NavigationButtonsComponent);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/Navigation/NavigationButtons/index.js